var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateArrowWhite02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.89258,
    y: 12.7085,
    width: 13.5606,
    height: 1.72198,
    transform: "rotate(-40.2798 3.89258 12.7085)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.80664,
    y: 4.31445,
    width: 1.72198,
    height: 1.72198,
    transform: "rotate(-40.2798 5.80664 4.31445)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.23242,
    y: 4.51465,
    width: 1.72198,
    height: 1.72198,
    transform: "rotate(-40.2798 8.23242 4.51465)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6602,
    y: 4.71436,
    width: 1.72198,
    height: 1.72198,
    transform: "rotate(-40.2798 10.6602 4.71436)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8867,
    y: 7.34229,
    width: 1.72198,
    height: 1.72198,
    transform: "rotate(-40.2798 12.8867 7.34229)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6875,
    y: 9.76953,
    width: 1.72198,
    height: 1.72198,
    transform: "rotate(-40.2798 12.6875 9.76953)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4863,
    y: 12.1963,
    width: 1.72198,
    height: 1.72198,
    transform: "rotate(-40.2798 12.4863 12.1963)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrowWhite02);
export default __webpack_public_path__ + "assets/media/rotate-arrow-white02.323fe1a5fd6246231d4e02f0763ffc8d.svg";
export { ForwardRef as ReactComponent };